import React, { useState, useEffect, useCallback } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import { CSVLink } from "react-csv";
import {
  TableWarpper,
  TabsDetailsWrapper,
  Text,
  ButtonOutline,
} from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDownload from "../../assets/images/IconDownload";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Pagination from "../../components/common/Pagination";
import ItemPerPage from "../../components/common/ItemPerPage";
import TableLoader from "../../components/common/TableLoader";

const DEFAULT_PAGE_SIZE = 10;

export default function OrgHoldBalence() {
  const [holdBalenceList, setHoldBalenceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCsvDisabled, setIsCsvDisabled] = useState(false);

  const [paginationData, setPaginationData] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 1,
    currentPage: 0,
  });

  const { currentPage, pageSize, totalPages } = paginationData;
  const fetchHoldBalanceReport = useCallback(async () => {
    setLoading(true);

    const successHandler = (res) => {
      // Support multiple possible response shapes
      const meta = res?.data?.metaInfo || res?.metaInfo || res?.data || {};
      const data = Array.isArray(meta.data) ? meta.data : [];
      const totalPagesFromApi = meta.totalPages ?? meta.total ?? 1;
      const currentPageFromApi = meta.currentPage ?? 0;

      setHoldBalenceList(data);
      setPaginationData({
        pageSize,
        totalPages: totalPagesFromApi,
        currentPage: currentPageFromApi,
      });
      setLoading(false);
    };

    const errorHandler = (err) => {
      console.error("API Error:", err);
      toast.error(err?.message || "Failed to load hold balance report");
      setHoldBalenceList([]);
      setPaginationData({
        pageSize,
        totalPages: 1,
        currentPage: 0,
      });
      setLoading(false);
    };

    const api = new Request("", successHandler, errorHandler, false);
    const url = `${Config.apis.admin.ORG_HOLD_BALENCE_REPORTS}?page=${currentPage}&size=${pageSize}`;
    await api.get(url);
  }, [currentPage, pageSize]);


  const handleReleaseHoldAmount = async (uuid) => {
    if (!uuid) return;

    const successHandler = () => {
      toast.success("Hold amount released successfully!");
      fetchHoldBalanceReport();
    };

    const errorHandler = (err) => {
      toast.error(err?.message || "Failed to release hold amount");
    };

    const api = new Request("", successHandler, errorHandler, false);
    await api.post(`${Config.apis.admin.RELEASE_HOLD_BALANCE}/${uuid}`);
  };

  const csvHeaders = [
    { label: "User ID", key: "userId" },
    { label: "Transaction Mode", key: "transactionMode" },
    { label: "Transaction Amount", key: "transactionAmount" },
    { label: "Status", key: "status" },
    { label: "Amount", key: "amount" },
    { label: "Check No", key: "chequeNo" },
    { label: "Date", key: "transactionDate" },
    { label: "Debit/Credit", key: "debitCredit" },
    { label: "Remitter Bank", key: "remitterBank" },
    { label: "Remitter IFSC", key: "remitterIFSC" },
    { label: "Remitter Name", key: "remitterName" },
    { label: "Remitter Account", key: "remitterAccount" },
    { label: "Account Number", key: "accountnumber" },
    { label: "Virtual Account", key: "virtualAccount" },
    { label: "Mnemonic Code", key: "mnemonicCode" },
    { label: "Alert Sequence Number", key: "alertSequenceNo" },
    { label: "User Reference Number", key: "userReferenceNumber" },
    { label: "Transaction Description", key: "transactionDescription" },
  ];

  const csvData = holdBalenceList.map((item) => {
    let parsed = {};
    try {
      parsed = item.requestJson ? JSON.parse(item.requestJson) : {};
    } catch (e) {
      parsed = {};
    }
    return {
      userId: item.userId || "",
      transactionMode: item.transactionMode || "",
      transactionAmount: item.transactionAmount || "",
      status: item.status || "",
      amount: parsed.amount || "",
      chequeNo: parsed.chequeNo || "",
      transactionDate: parsed.transactionDate || "",
      debitCredit: parsed.debitCredit || "",
      remitterBank: parsed.remitterBank || "",
      remitterIFSC: parsed.remitterIFSC || "",
      remitterName: parsed.remitterName || "",
      remitterAccount: parsed.remitterAccount || "",
      accountnumber: parsed.accountnumber || "",
      virtualAccount: parsed.virtualAccount || "",
      mnemonicCode: parsed.mnemonicCode || "",
      alertSequenceNo: parsed.alertSequenceNo || "",
      userReferenceNumber: parsed.userReferenceNumber || "",
      transactionDescription: parsed.transactionDescription || "",
    };
  });

  const handleCsvClick = () => {
    setIsCsvDisabled(true);
    setTimeout(() => setIsCsvDisabled(false), 15000);
  };

  const setCurrentPage = (page) => {
    setPaginationData((prev) => ({ ...prev, currentPage: page }));
  };

  const setPageSize = (size) => {
    setPaginationData((prev) => ({
      ...prev,
      pageSize: size,
      currentPage: 0,
    }));
  };

 
  useEffect(() => {
    fetchHoldBalanceReport();
  }, [fetchHoldBalanceReport]);

  return (
    <Wrapper>
      {/* Header */}
      <div className="flex flex-center space-between mb10">
        <Heading size="xxl">Org Hold Balance Report</Heading>

        <div className="flex gap10">
          <span
            onClick={isCsvDisabled ? (e) => e.preventDefault() : handleCsvClick}
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
          >
            <CSVLink headers={csvHeaders} data={csvData} filename="HoldBalanceReport.csv">
              <ButtonOutline
                as="span"
                className="flex flex-center"
                primary
                rg
                disabled={isCsvDisabled}
                style={{
                  pointerEvents: isCsvDisabled ? "none" : "auto",
                  opacity: isCsvDisabled ? 0.6 : 1,
                }}
              >
                <IconDownload className="mr8" /> CSV
              </ButtonOutline>
            </CSVLink>
          </span>
        </div>
      </div>

      {/* Table + Loader */}
      <TabsDetailsWrapper className="pd-bottom" style={{ maxWidth: "100%" }}>
        {loading ? (
          <div className="table-loader-wrapper animatedBackground">
            <TableLoader />
          </div>
        ) : (
          <TableWarpper className="mt24" style={{ maxWidth: "100%", overflowX: "auto" }}>
            <table className="table" style={{ width: "100%", minWidth: "1200px" }}>
              <thead>
                <tr>
                  {[
                    "S.No.",
                    "User ID",
                    "Transaction Mode",
                    "Transaction Amount",
                    "Status",
                    "AMOUNT",
                    "CHECK NO",
                    "DATE",
                    "DEBIT/CREDIT",
                    "REMITTER BANK",
                    "REMITTER IFSC",
                    "REMITTER NAME",
                    "REMITTER ACCOUNT",
                    "ACCOUNT NUMBER",
                    "VIRTUAL ACCOUNT",
                    "MNEMONIC CODE",
                    "ALERT SEQUENCE NUMBER",
                    "USER REFERENCE NUMBER",
                    "TRANSACTION DESCRIPTION",
                  ].map((h) => (
                    <th key={h} className="text-left">
                      <Text size="rg" fw="medium">{h}</Text>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {holdBalenceList.length > 0 ? (
                  holdBalenceList.map((balence, index) => {
                    let parsed = {};
                    try {
                      parsed = balence.requestJson ? JSON.parse(balence.requestJson) : {};
                    } catch (e) {
                      parsed = {};
                    }

                    return (
                      <tr key={balence.uuid || index}>
                        <td>
                          <Text size="xsm" color="color3">
                            {currentPage * pageSize + index + 1}
                          </Text>
                        </td>
                        <td><Text size="xsm" color="color3">{balence.userId || "NA"}</Text></td>
                        <td><Text size="xsm" color="color3">{balence.transactionMode || "NA"}</Text></td>
                        <td><Text size="xsm" color="color3">{balence.transactionAmount || "NA"}</Text></td>
                        <td><Text size="xsm" color="color3">{balence.status || "NA"}</Text></td>
                        <td>{parsed.amount ?? "N/A"}</td>
                        <td>{parsed.chequeNo ?? "N/A"}</td>
                        <td>{parsed.transactionDate ?? "N/A"}</td>
                        <td>{parsed.debitCredit ?? "N/A"}</td>
                        <td>{parsed.remitterBank ?? "N/A"}</td>
                        <td>{parsed.remitterIFSC ?? "N/A"}</td>
                        <td>{parsed.remitterName ?? "N/A"}</td>
                        <td>{parsed.remitterAccount ?? "N/A"}</td>
                        <td>{parsed.accountnumber ?? "N/A"}</td>
                        <td>{parsed.virtualAccount ?? "N/A"}</td>
                        <td>{parsed.mnemonicCode ?? "N/A"}</td>
                        <td>{parsed.alertSequenceNo ?? "N/A"}</td>
                        <td>{parsed.userReferenceNumber ?? "N/A"}</td>
                        <td>{parsed.transactionDescription ?? "N/A"}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={19} style={{ textAlign: "center", lineHeight: "30px" }}>
                      No record found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </TableWarpper>
        )}
      </TabsDetailsWrapper>

      {/* Pagination */}
      <div className="mt24 flex flex-center">
        {holdBalenceList.length > 0 && (
          <ItemPerPage
            pageSize={pageSize}
            getPageSize={setPageSize}
          />
        )}
        {totalPages > 1 && (
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage + 1}
            getCurrentPageData={(page) => setCurrentPage(page - 1)}
          />
        )}
      </div>

    </Wrapper>
  );
}